import axios from 'axios';
const config = {
  headers: {
    Authorization: localStorage.getItem('Authorization') || null
  }
};

const $axios = axios.create(config);
export default $axios;